module.exports = __webpack_public_path__ + "img/green_calendar.76530052.svg";